<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter" role="doc-chapter">
<div class="epigraph" role="doc-epigraph">
<div class="senseline">
<p class="epslf"><span aria-label=" Page vi. " class="page" epub:type="pagebreak" id="pvi" role="doc-pagebreak"></span><span aria-label=" Page vii. " class="page" epub:type="pagebreak" id="pvii" role="doc-pagebreak"></span>Words are hoops</p>
<p class="epsl">Through which to leap upon meanings,</p>
<p class="epsl">Which are horses’ backs,</p>
<p class="epsl">Bare, moving.</p>
</div>
<p class="ept"><i>Witter Bynner, “Horses,” 1919</i></p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-Fischer-OA-0006.vue?3c0d8083